import React, { useState } from "react";
import styles from "./ForecastTabs.module.css";
import ForecastDay from "./ForecastDay";
import ForecastTomorrow from "./ForecastTomorrow";
import ForecastWeek from "./ForecastWeek";
import ForecastMonth from "./ForecastMonth";
import ForecastYear from "./ForecastYear";

const TABS = [
  { key: "day", label: "Сегодня" },
  { key: "tomorrow", label: "Завтра" },
  { key: "week", label: "Неделя" },
  { key: "month", label: "Месяц" },
  { key: "year", label: "Год" },
];

const TABS_VISIBLE = 3; // сколько показываем табов на мобиле

const ForecastTabs: React.FC = () => {
  const [activeTab, setActiveTab] = useState("day");
  const [scrollIndex, setScrollIndex] = useState(0);

  // для адаптива
  const isMobile = window.innerWidth < 470;

  // фильтруем табы для карусели
  const visibleTabs = isMobile ? TABS.slice(scrollIndex, scrollIndex + TABS_VISIBLE) : TABS;

  const showPrev = isMobile && scrollIndex > 0;
  const showNext = isMobile && scrollIndex < TABS.length - TABS_VISIBLE;

  return (
    <div>
      <div className={styles.tabsWrapper}>
        {showPrev && (
          <button
            className={styles.arrowButton}
            onClick={() => setScrollIndex((i) => Math.max(0, i - 1))}
            aria-label="Назад"
            type="button"
          >
            <svg width={24} height={24} viewBox="0 0 24 24">
              <path
                d="M15 6l-6 6 6 6"
                stroke="#fff"
                strokeWidth={2}
                fill="none"
                strokeLinecap="round"
              />
            </svg>
          </button>
        )}
        <div className={styles.tabs}>
          {visibleTabs.map((tab) => (
            <button
              key={tab.key}
              className={`${styles.tab} ${activeTab === tab.key ? styles.active : ""}`}
              onClick={() => setActiveTab(tab.key)}
              type="button"
            >
              {tab.label}
            </button>
          ))}
        </div>
        {showNext && (
          <button
            className={styles.arrowButton}
            onClick={() => setScrollIndex((i) => Math.min(TABS.length - TABS_VISIBLE, i + 1))}
            aria-label="Вперед"
            type="button"
          >
            <svg width={24} height={24} viewBox="0 0 24 24">
              <path
                d="M9 6l6 6-6 6"
                stroke="#fff"
                strokeWidth={2}
                fill="none"
                strokeLinecap="round"
              />
            </svg>
          </button>
        )}
      </div>
      <div className={styles.tabContent}>
        {activeTab === "day" && <ForecastDay />}
        {activeTab === "tomorrow" && <ForecastTomorrow />}
        {activeTab === "week" && <ForecastWeek />}
        {activeTab === "month" && <ForecastMonth />}
        {activeTab === "year" && <ForecastYear />}
      </div>
    </div>
  );
};

export default ForecastTabs;
